import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }    from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

@Component({
  selector   : 'customer-inspections',
  template: require('./customer.inspections.html')
})
export class CustomerInspectionsComponent implements OnInit {
  @Input() customer: any;
  @Input() inspections: any[];

  columns: any[];
  showCustomerInspections: boolean;
  tableCacheKey: string;
  tableSettings: any;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => TableService)) private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showCustomerInspections = !!this.inspections.length;
    this.tableCacheKey           = 'customerInspections';

    this.columns = [
      {
        field : 'inspection_number',
        header: {
          text: this.translateService.instant('INSPECTIONS_SPACE.INSPECTION_NUMBER')
        },
        width: '14%'
      },
      {
        field : 'inspection_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'inspection_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'inspectionStatus'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => this.viewInspection(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ];

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('INSPECTIONS_SPACE.NO_INSPECTIONS')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/inspection_count/' + this.customer.id)
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'asc',
        field    : 'inspection_date'
      }),
    };
  }

  getInspections ( params ): Promise<any> {
    return this.apiService.get('/customers/inspection_list', [
      this.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then((inspections) => {
      this.inspections = inspections;

      return inspections;
    });
  }

  onRowDoubleClick ( event: any ): void {
    this.router.stateService.go('app.inspection', {
      customer_id: this.customer.id,
      id         : event.row.id,
      vehicle_id : event.row.vehicle_id
    });
  }

  viewInspection ( inspection: any ): void {
    this.router.stateService.go('app.inspection', {
      customer_id: this.customer.id,
      id         : inspection.id,
      vehicle_id : inspection.vehicle_id
    });
  }
}
